import { actions } from 'react-redux-form';
import { httpGet } from '../../../../utils/api.utils';
import { CIRCUIT_SIM_RANK } from '../../../../constants/external-constants';
import {
    getCircuitSimList,
    deleteCircuitSimItem,
    addCircuitSimItem,
    updateCircuitSimItem,
    resetCircuitSIMDetails,
    circuitSimFormModel,
    getCircuitOrderSimList
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/add-sim.settings";

import { compareIgnoreCase } from "../../../../utils/helpers.utils";

export const circuitSimFormInitialState = circuitSimFormModel;

const defaultState = () => ({
    circuitSimList: {
        datatable: []
    },
    simTypes: [],
    simRanks: []
});

const initialState = defaultState();

export const inventoryCircuitSimActions = {
    getCircuitSimList: (circuitId) => async (dispatch, state) => {
        var data = await httpGet('external/inventory/getCircuitSimList/' + circuitId);

        if (data.datatable.length > 0 && data.datatable[0].dataItem.length > 0) {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Secondary));
        }
        else {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Primary));
        }

        dispatch({
            type: getCircuitSimList,
            datatable: data.datatable,
            simTypes: data.simTypes,
            simRanks: data.simRanks
        });
    },

    getCircuitOrderSimList: (orderDetailsId, requestTypeId, orderCircuitDetailId = 0) => async (dispatch, state) => {
        var data = await httpGet('external/order/getCircuitOrderSimList/' + orderDetailsId + '/' + requestTypeId + '/' + orderCircuitDetailId);

        if (data.datatable && data.datatable.length > 0 && data.datatable[0].dataItem.length > 0) {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Secondary));
        }
        else {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Primary));
        }

        dispatch({
            type: getCircuitOrderSimList,
            datatable: data.datatable,
            simTypes: data.simTypes,
            simRanks: data.simRanks
        });
    },
    deleteCircuitSimItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitSIM.circuitSimList;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var newDataItem = [...dataItem];
        newDataItem.splice(index, 1);

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: deleteCircuitSimItem,
            datatable: newDataTable
        });

        if (newDataTable.length > 0 && newDataTable[0].dataItem.length > 0) {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Secondary));
        }
        else {
            dispatch(actions.load("inventoryCircuitSIMForm.Rank", CIRCUIT_SIM_RANK.Primary));
        }
    },
    addCircuitSimItem: () => (dispatch, state) => {
        const { simTypes } = state().inventoryCircuitSIM;
        const { datatable } = state().inventoryCircuitSIM.circuitSimList;
        const { inventoryCircuitSIMForm } = state().form;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var simTypeValue = simTypes.filter(r => r.FilterValue == inventoryCircuitSIMForm.TypeID);

        var newDataItem = [
            ...dataItem,
            {
                ...inventoryCircuitSIMForm,
                ID: -1,
                Type: simTypeValue.length > 0 ? simTypeValue[0].FilterName : null,
            }
        ].sort((a, b) => compareIgnoreCase(a.Rank, b.Rank));

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addCircuitSimItem,
            datatable: newDataTable
        });
    },
    updateCircuitSimItem: () => (dispatch, state) => {
        const { simTypes } = state().inventoryCircuitSIM;
        const { datatable } = state().inventoryCircuitSIM.circuitSimList;
        const { inventoryCircuitSIMForm } = state().form;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var indexItem = inventoryCircuitSIMForm.ID;
        var simTypeValue = simTypes.filter(r => r.FilterValue == inventoryCircuitSIMForm.TypeID);

        dataItem[indexItem] = {
            ...inventoryCircuitSIMForm,
            ID: dataItem[indexItem].ID,
            Type: simTypeValue.length > 0 ? simTypeValue[0].FilterName : null,
        };

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateCircuitSimItem,
            datatable: newDataTable
        });
    },
    viewCircuitSimItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitSIM.circuitSimList;

        var dataItem = datatable[0].dataItem[index];

        dataItem = {
            ...dataItem,
            ID: index
        };

        dispatch(actions.reset("inventoryCircuitSIMForm"));
        dispatch(actions.change("inventoryCircuitSIMForm", dataItem));

    },
    resetCircuitSimForm: () => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitSIM.circuitSimList;

        let defaultRank = CIRCUIT_SIM_RANK.Primary;
        if (datatable.length > 0 && datatable[0].dataItem.length > 0) {
            defaultRank = CIRCUIT_SIM_RANK.Secondary;
        }

        const formData = {
            ...circuitSimFormModel,
            Rank: defaultRank
        };

        dispatch(actions.change("inventoryCircuitSIMForm", formData));
    },
    resetCircuitSimDetails: () => (dispatch, state) => {
        dispatch({
            type: resetCircuitSIMDetails,
            circuitSimList: {
                datatable: []
            },
            simTypes: [],
            simRanks: []
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitSimList:
            return {
                ...state,
                circuitSimList: {
                    ...state.circuitSimList,
                    datatable: action.datatable
                },
                simTypes: action.simTypes,
                simRanks: action.simRanks
            };
        case getCircuitOrderSimList:
            return {
                ...state,
                circuitSimList: {
                    ...state.circuitSimList,
                    datatable: action.datatable
                },
                simTypes: action.simTypes,
                simRanks: action.simRanks
            };
        case addCircuitSimItem:
            return {
                ...state,
                circuitSimList: {
                    ...state.circuitSimList,
                    datatable: action.datatable
                }
            };
        case updateCircuitSimItem:
            return {
                ...state,
                circuitSimList: {
                    ...state.circuitSimList,
                    datatable: action.datatable
                }
            };
        case deleteCircuitSimItem:
            return {
                ...state,
                circuitSimList: {
                    ...state.circuitSimList,
                    datatable: action.datatable
                }
            };
        case resetCircuitSIMDetails:
            return {
                ...state,
                circuitSimList: action.circuitSimList,
                simTypes: action.simTypes,
                simRanks: action.simRanks
            };
        default:
            return state;
    }
}